import { IoIosArrowDown } from "react-icons/io";
import { AiOutlineClear } from "react-icons/ai";
import Divider from "../../components/Divider";
import IconText from "../../components/IconText";

const DietitiansFilter = (props) => {
  const peerChecked =
    "peer-checked:border-[#dc7143] peer-checked:border-[10px] peer-checked:before:opacity-100 before:border-white before:opacity-0 before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-y-1/2 before:-translate-x-1/2 before:border-0 before:border-b-2 before:border-r-2 before:border-white before:rotate-45 before:h-[10px] before:w-[5px] before:transition-all before:duration-500 before:delay-150";

  return (
    <div>
      <div className="filers-wrapper text-[13px] font-semibold p-2 flex">
        <div className="single-filter ml-2 relative">
          <div
            className="selected flex items-center cursor-pointer"
            onClick={() => props.handleClick(0)}
          >
            <span className="inline-block px-3 py-3">Sessions</span>
            <span className="flex items-center h-5 w-5">
              <IoIosArrowDown className="text-[12px]" />
            </span>
          </div>
          <div
            role={"listbox"}
            className={`options text-sm font-normal bg-white rounded-lg min-w-[250px] w-full overflow-hidden absolute transition-all duration-300 shadow-lg z-20 ${
              props.activeListbox === 0
                ? "opacity-100 max-h-[9999px]"
                : "opacity-0 translate-y-2 max-h-0"
            }`}
          >
            <ul className="flex flex-col p-4">
              <li className="mb-4 last:mb-0">
                <label
                  htmlFor="session_1"
                  className="flex items-center cursor-pointer"
                >
                  <input
                    type="radio"
                    id="session_1"
                    name="price"
                    className="peer hidden"
                  />
                  <span
                    className={`checked inline-block h-5 w-5 border-2 rounded-full border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
                  ></span>
                  <span>Food Making</span>
                </label>
              </li>
              <li className="mb-4 last:mb-0">
                <label
                  htmlFor="session_2"
                  className="flex items-center cursor-pointer"
                >
                  <input
                    type="radio"
                    id="session_2"
                    name="price"
                    className="peer hidden"
                  />
                  <span
                    className={`checked inline-block h-5 w-5 border-2 rounded-full border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
                  ></span>
                  <span>30 Minutes anything</span>
                </label>
              </li>
              <li className="mb-4 last:mb-0">
                <label
                  htmlFor="session_3"
                  className="flex items-center cursor-pointer"
                >
                  <input
                    type="radio"
                    id="session_3"
                    name="price"
                    className="peer hidden"
                  />
                  <span
                    className={`checked inline-block h-5 w-5 border-2 rounded-full border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
                  ></span>
                  <span>Monthly</span>
                </label>
              </li>
              <li className="mb-4 last:mb-0">
                <label
                  htmlFor="session_4"
                  name="price"
                  className="flex items-center cursor-pointer"
                >
                  <input
                    type="radio"
                    id="session_4"
                    name="price"
                    className="peer hidden"
                  />
                  <span
                    className={`checked inline-block h-5 w-5 border-2 rounded-full border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
                  ></span>
                  <span>Special Sessions</span>
                </label>
              </li>
            </ul>
            <Divider />
            <div className="actions px-4 py-2 flex justify-end">
              <button className="bg-gray-100 transition-all duration-200 px-3 py-2 rounded-md">
                <IconText
                  iconFirst
                  iconInfo={{ Icon: AiOutlineClear, classes: "h-4 w-4" }}
                  textInfo={{ text: "Clear" }}
                />
              </button>
            </div>
          </div>
        </div>
        <div className="single-filter ml-2 relative xs:mb-2 md:mb-0">
          <div
            className="selected flex items-center cursor-pointer"
            onClick={() => props.handleClick(1)}
          >
            <span className="inline-block px-3 py-3">Sessions</span>
            <span className="flex items-center h-5 w-5">
              <IoIosArrowDown className="text-[12px]" />
            </span>
          </div>
          <div
            role={"listbox"}
            className={`options text-sm font-normal bg-white rounded-lg min-w-[250px] w-full overflow-hidden absolute transition-all duration-300 shadow-lg z-20 ${
              props.activeListbox === 1
                ? "opacity-100 max-h-[9999px]"
                : "opacity-0 translate-y-2 max-h-0"
            }`}
          >
            <ul className="flex flex-col p-4">
              <li className="mb-4 last:mb-0">
                <label
                  htmlFor="nutrition_1"
                  className="flex items-center cursor-pointer"
                >
                  <input
                    type="checkbox"
                    id="nutrition_1"
                    className="peer hidden"
                  />
                  <span
                    className={`checked inline-block h-5 w-5 border-2 rounded border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
                  ></span>
                  <span>Food Making</span>
                </label>
              </li>
              <li className="mb-4 last:mb-0">
                <label
                  htmlFor="nutrition_2"
                  className="flex items-center cursor-pointer"
                >
                  <input
                    type="checkbox"
                    id="nutrition_2"
                    className="peer hidden"
                  />
                  <span
                    className={`checked inline-block h-5 w-5 border-2 rounded border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
                  ></span>
                  <span>30 Minutes anything</span>
                </label>
              </li>
              <li className="mb-4 last:mb-0">
                <label
                  htmlFor="nutrition_3"
                  className="flex items-center cursor-pointer"
                >
                  <input
                    type="checkbox"
                    id="nutrition_3"
                    className="peer hidden"
                  />
                  <span
                    className={`checked inline-block h-5 w-5 border-2 rounded border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
                  ></span>
                  <span>Monthly</span>
                </label>
              </li>
              <li className="mb-4 last:mb-0">
                <label
                  htmlFor="nutrition_4"
                  className="flex items-center cursor-pointer"
                >
                  <input
                    type="checkbox"
                    id="nutrition_4"
                    className="peer hidden"
                  />
                  <span
                    className={`checked inline-block h-5 w-5 border-2 rounded border-[#9e9e9e] mr-2 transition-all duration-200 relative ${peerChecked}`}
                  ></span>
                  <span>Special Sessions</span>
                </label>
              </li>
            </ul>
            <Divider />
            <div className="actions px-4 py-2 flex justify-end">
              <button className="bg-gray-100 transition-all duration-200 px-3 py-2 rounded-md">
                <IconText
                  iconFirst
                  iconInfo={{ Icon: AiOutlineClear, classes: "h-4 w-4" }}
                  textInfo={{ text: "Clear" }}
                />
              </button>
            </div>
          </div>
        </div>
        <div className="single-filter ml-2 flex items-center">
          <div className="options text-[#616161] text-[12px] font-medium flex flex-wrap">
            <div
              className="single-option my-1 mr-2 last:mr-0"
              onClick={() => props.handleClick(null)}
            >
              <label htmlFor="option_1">
                <input
                  type="radio"
                  name="name"
                  id="option_1"
                  className="peer"
                  hidden
                />
                <span className="inline-block py-2 px-5 rounded-full border border-[#e7e7e7] peer-checked:border-[#e56652] peer-checked:bg-[#fbebeb] peer-checked:text-[#e56652] cursor-pointer">
                  View All
                </span>
              </label>
            </div>
            <div
              className="single-option my-1 mr-2 last:mr-0"
              onClick={() => props.handleClick(null)}
            >
              <label htmlFor="option_2">
                <input
                  type="radio"
                  name="name"
                  id="option_2"
                  className="peer"
                  hidden
                />
                <span className="inline-block py-2 px-5 rounded-full border border-[#e7e7e7] peer-checked:border-[#e56652] peer-checked:bg-[#fbebeb] peer-checked:text-[#e56652] cursor-pointer">
                  Virtual
                </span>
              </label>
            </div>
            <div
              className="single-option my-1 mr-2 last:mr-0"
              onClick={() => props.handleClick(null)}
            >
              <label htmlFor="option_3">
                <input
                  type="radio"
                  name="name"
                  id="option_3"
                  className="peer"
                  hidden
                />
                <span className="inline-block py-2 px-5 rounded-full border border-[#e7e7e7] peer-checked:border-[#e56652] peer-checked:bg-[#fbebeb] peer-checked:text-[#e56652] cursor-pointer">
                  In-person
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DietitiansFilter;
